import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Dialog from '../common/dialog'
import { UserContext } from '../../contexts'
import { numberWithCommas } from '../../utils'
import CalculateIcon from '../../assets/icons/calculate-icon.svg'
import { ExchangeCalculatorForm } from './exchange-calculator-form'
import { useNavigate } from 'react-router-dom'

export const ClientAvailableBalanceBrief = ({
  currency,
  dataLoaded,
  balanceToBeDebited,
  balanceToBeCredited,
  totalAvailableBalance
}: {
  currency: string
  dataLoaded?: boolean
  balanceToBeDebited: number
  balanceToBeCredited: number
  totalAvailableBalance: number
}) => {
  const navigate = useNavigate()
  const { userSession } = useContext(UserContext)
  const { t } = useTranslation(['banks-balances-management', 'pockets-management'])

  const [dialogCalculateYourFundsIsOpen, setDialogCalculateYourFundsIsOpen] = useState(false)

  return (
    <>
      <div
        className="bank-balance-square-container"
        style={String(userSession?.belongsTo) === '67237f891071ccf4fd8ebc28' ? { cursor: 'pointer' } : {}}
        onClick={() => {
          if (String(userSession?.belongsTo) === '67237f891071ccf4fd8ebc28') {
            navigate('/customer-company-fundings-history/67237f891071ccf4fd8ebc28', {
              state: {
                companyName: 'PAXUM COMPANY',
                previousPath: '/'
              }
            })
          }
        }}
      >
        <div className="bank-balance-square-info-container">
          {dataLoaded ? (
            <div
              style={{ fontSize: '22px' }}
              className="bank-balance-square-main-data"
            >
              {currency === 'BRL' ? `$ ${numberWithCommas(Number(totalAvailableBalance) ?? 0)} ${currency}` : `$ ${numberWithCommas(Math.round(Number(totalAvailableBalance)) ?? 0)} ${currency}`}
            </div>
          ) : (
            <>
              <div
                className="data-container-loader"
                style={{ padding: '12px', width: '200px', alignSelf: 'center' }}
              ></div>
              <div
                className="data-container-loader"
                style={{ padding: '6px', width: '100px', alignSelf: 'center' }}
              ></div>
            </>
          )}
          <div className={userSession && userSession?.role.indexOf('-client') > -1 ? 'bank-balance-square-main-data bank-balance-square-main-data-with-calculation' : 'bank-balance-square-main-data'}>
            <div style={{ fontSize: '20px', color: '#004A5C' }}>{t('clientSquareAssignedBalanceBrief.text')}</div>
            {userSession && userSession?.role.indexOf('-client') > -1 && (
              <div
                className="exchange-rate-calculator-button-container"
                onClick={() => setDialogCalculateYourFundsIsOpen(true)}
              >
                <img
                  src={CalculateIcon}
                  alt="calculate-icon"
                />
              </div>
            )}
          </div>
          <div className="balance-brief">
            <div className="balance-items-container">
              <div className="balance-subitems">
                <div>{`${t('pocketActions.toBeDebited', { ns: 'pockets-management' })}:`}</div> <div>{`$ ${numberWithCommas(Number(balanceToBeDebited))} ${currency}`}</div>
              </div>
              <div className="balance-subitems">
                <div>{`${t('pocketActions.toBeCredited', { ns: 'pockets-management' })}:`}</div> <div>{`$ ${numberWithCommas(Number(balanceToBeCredited))} ${currency}`}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {dialogCalculateYourFundsIsOpen && (
        <Dialog
          hideActionsButtons
          dialogTitle={t('calculateYourFundsModal.title', { ns: 'banks-balances-management' })}
          handleDialogOpenState={(openState: boolean) => setDialogCalculateYourFundsIsOpen(openState)}
        >
          <ExchangeCalculatorForm />
        </Dialog>
      )}
    </>
  )
}
